import { parse } from 'query-string';
import { aws } from './../helpers';
import Moment from 'moment';
import {
  LOCATION_CHANGE,
  SET_AWS_SYNC_DATETIME,
  SORT_AWS_COST_TABLE
} from './../actions';

const initialState = {
  account: aws.DEFAULTACCOUNT,
  region: aws.DEFAULTREGION,
  latestSyncDatetime: Moment().format('YYYY-MM-DD, h:mm:ss a'),
  sortingKey: 'yesterday',
  currentSortingOrders:
  {
    id: '',
    name: '',
    instanceType: '',
    owner: '',
    account: '',
    region: '',
    bestBefore: '',
    yesterday: 'desc',
    today: '',
    tomorrow: '',
    annualized: ''
  }
};

const awsPageInfo = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      if (!action.payload ||
          !action.payload.search ||
          action.payload.pathname !== '/aws-instances-cost') {
        return state;
      }
      // These are:
      // a: current aws account
      // r: current aws region
      // The names need to be short because they're part of the URL query.
      const { a, r } = parse(action.payload.search);
      const parseAwsPageInfo = (
        account,
        region
      ) => {
        return {
          account: account,
          region: region
        };
      };

      const parsedInfo = parseAwsPageInfo(a, r);
      return {
        ...state,
        account: parsedInfo.account,
        region: parsedInfo.region
      };

    case SET_AWS_SYNC_DATETIME:
      return {
        ...state,
        latestSyncDatetime: action.datetime
      };

    case SORT_AWS_COST_TABLE:
      return {
        ...state,
        sortingKey: action.sortingKey,
        currentSortingOrders:
        {
          ...state.currentSortingOrders,
          [action.sortingKey]: state.currentSortingOrders[action.sortingKey] === 'desc' ?
            'asc' : 'desc'
        }
      };

    default:
      return state;
  }
};

export default awsPageInfo;

const getAWSPageInfo = state => state.awsPageInfo;
export const getAWSRegion = state =>
  getAWSPageInfo(state).region;
export const getAWSAccount = state =>
  getAWSPageInfo(state).account;
export const getLastestAWSSyncDatetime = state =>
  getAWSPageInfo(state).latestSyncDatetime;
export const getAWSTableSortingKey = state =>
  getAWSPageInfo(state).sortingKey;
export const getAWSTableCurrentSortingOrders = state =>
  getAWSPageInfo(state).currentSortingOrders;


// WEBPACK FOOTER //
// src/reducers/awsPageInfo.js